

export default {
  setup(_props, { emit }) {
    const onChange = (e) => {
      emit('input', e)
    }

    return {
      onChange
    }
  }
}
